

import { useState, useRef, useLayoutEffect } from 'preact/hooks'


// run callback when an element is scrolled into view
// requires polyfill for IE11


export const onIntersection = (el, callback, rootMargin = '0px 0px', once = false) => {

	if (!global.IntersectionObserver) {
		callback(null, null)
		return
	}
	const observer = new IntersectionObserver(handleIntersection, {
		rootMargin : rootMargin,
		threshold: [0, 1]
	})
	observer.observe(el)

	function handleIntersection(entries, observer) {
		if (!entries[0]) return

		if (once) {
			if (entries?.[0]?.intersectionRatio > 0) {
				observer.unobserve(el)
				callback(entries[0], observer)
			}
			return
		}

		callback(entries[0], observer)
	}

	return () => observer.unobserve(el)
}


export const onIntersectionOnce = (el, callback, rootMargin = '0px 0px') => onIntersection(el, callback, rootMargin, true)


export const useIsIntersecting = (rootMargin, once = false) => {

	const [shown, setShown] = useState(false)
	const ref = useRef()

	if (!global.IntersectionObserver) return [ref, true]

	useLayoutEffect(() => {
		if (!ref.current) return false
		return onIntersection(
			ref.current, 
			(entry) => setShown(entry.isIntersecting),
			rootMargin,
			once
		)
	}, [])

	return [ ref, shown ]
}
